import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-brand-black" data-id="element-79">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 bg-[length:24px_24px] bg-subtle-pattern opacity-20" data-id="element-80"></div>

      {/* Gradient overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-black/50 to-brand-black" data-id="element-81"></div>

      <div className="relative z-10 flex flex-col items-center justify-center px-6 text-center w-full max-w-4xl mx-auto" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-83">
          <div className="w-px h-16 bg-brand-gold/50 mb-10" data-id="element-84"></div>
          <h1 className="font-serif text-6xl md:text-8xl lg:text-9xl text-brand-offwhite mb-6 tracking-wider uppercase" data-id="element-85">
            Grill <span className="text-brand-gold" data-id="element-86">211</span>
          </h1>
          <div className="w-24 h-px bg-brand-gold/60 mb-6" data-id="element-87"></div>
          <p className="font-serif text-xl md:text-2xl text-brand-offwhite/70 mb-4 tracking-wide italic" data-id="element-88">
            Fine Dining & Craft Cocktails
          </p>
          <p className="text-brand-offwhite/50 tracking-widest uppercase text-sm md:text-base" data-id="element-89">
            211 Broadway ~ Paducah, KY
          </p>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center" data-id="element-90">
        <span className="text-[10px] tracking-[0.2em] uppercase text-brand-gold mb-4" data-id="element-91">
          Scroll
        </span>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} className="w-px h-12 bg-gradient-to-b from-brand-gold to-transparent" data-id="element-92" />
      </motion.div>
    </section>;
}